import clsx from 'clsx';

interface IHintProps {
  text?: string;
  className?: string;
  icon?: string;
  type?: string;
}

export const defaultHints = {
  pdfPageBreak: {
    text: 'Start new page in PDF with this module',
    className: 'pdf-page-break-hint',
    icon: 'play',
  },
};

export const Hint = ({ text, className, icon, type }: IHintProps) => {
  if (type) {
    text = defaultHints[type].text;
    className = defaultHints[type].className;
    icon = defaultHints[type].icon;
  }

  const classes = clsx({
    [className]: true,
  });

  const iconClasses = clsx({
    'c-icon-custom': true,
    ['c-icon-custom--' + icon]: true,
  });

  return (
    <p className={classes}>
      <i className={iconClasses} />
      {text}
    </p>
  );
};

export default Hint;
